<template>
    <div class="start_choice">
        <div class="start_choice__message">
            <div class="start_choice__message_text">
                {{ __t('O.IN_THE_SETTINGS_SELECT_RESTAURANTS_TO_ACCEPT_ORDERS') }}
            </div>
        </div>
        <div class="start_choice__block">
            <button class="start_choice__block_button " @click.prevent="selectRest">
                <div class="start_choice__block_button_text">
                    {{ __t('O.SELECT_RESTAURANTS') }}
                </div>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "start_choice_rest",
    emits: ['click_select_rest'],
    data() {
        return {}
    },
    methods: {
        selectRest() {
            EventBus.$emit('click_select_rest');
        }
    },
}
</script>
